"use client";

import { useMemo } from "react";

import { ListingStatus } from "@/.zenstack/logical-prisma-client";
import BaseListingCarousel from "@/components/listing-carousels/BaseListingCarousel";
import { LISTING_CARD_SELECT } from "@/components/listings/ListingCard";
import { useFindManyListing } from "@/lib/hooks/generated/tanstack-query";

export default function AuctionsEndingSoonCarousel() {
  // Use a stable date reference that doesn't change on every render
  const now = useMemo(() => new Date(), []);

  const carouselListings = useFindManyListing(
    {
      select: LISTING_CARD_SELECT,
      where: {
        status: ListingStatus.ACTIVE,
        atAuction: {
          is: {
            auctionStartDate: { lte: now },
            auctionEndDate: { gte: now },
          },
        },
      },
      take: 4,
      orderBy: { atAuction: { auctionEndDate: "asc" } },
    },
    {
      // Configure caching for 5 minutes
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  );

  return (
    <BaseListingCarousel
      heading="Ending soon"
      listings={carouselListings.data ?? []}
      isLoading={carouselListings.isLoading}
      emptyMessage="No active auctions ending soon. Please check back later."
    />
  );
}
